import {
  components,
  MultiValueGenericProps,
  MultiValueRemoveProps,
  OptionProps,
} from 'react-select';

import { Icon } from '@/shared/ui';

import { DoctorOptionType } from '../../config/types';
import { DoctorLabel } from '../DoctorLabel/DoctorLabel';

import styles from './DoctorsSelect.module.scss';

export const DoctorOption = (props: OptionProps<DoctorOptionType>) => {
  const {
    data: { label, avatarSrc },
    isSelected,
  } = props;
  return (
    <components.Option {...props}>
      <DoctorLabel avatarSrc={avatarSrc} fullName={label} />
      {isSelected && (
        <Icon name="check" size={32} className={styles.selectedIcon} />
      )}
    </components.Option>
  );
};

export const DoctorMultiValueLabel = (
  props: MultiValueGenericProps<DoctorOptionType>,
) => {
  const {
    data: { label, avatarSrc },
  } = props;

  return (
    <components.MultiValueLabel {...props}>
      <DoctorLabel avatarSrc={avatarSrc} fullName={label} />
    </components.MultiValueLabel>
  );
};

export const DoctorMultiValueRemove = (
  props: MultiValueRemoveProps<DoctorOptionType>,
) => (
  <components.MultiValueRemove {...props}>
    <Icon name="close" size={24} />
  </components.MultiValueRemove>
);
